<template lang="pug">
yz-dialog(v-model="showDialog" persistent max-width="500")
  yz-card
    yz-dialog-normal-header(title="Individual e-Invoice resubmission" @close="onCancel")
    yz-dialog-normal-content.px-6.py-6
      .d-flex.align-center.mb-2(style="gap: 8px")
        v-icon(size="20" color="danger500") $yzi-alert-circle
        .yz-medium-body-md.neutral700--text Do you want to submit this invoice individually?
      .pa-4.rounded-lg.border-solid.border-neutral-300.bg-neutral-200.mb-4
        v-row(no-gutters)
          v-col(cols="6")
            .yz-regular-body-sm.neutral500--text Invoice number
            .yz-regular-body-sm.neutral500--text.mt-3 Total
          v-col(cols="6")
            .yz-regular-body-sm.neutral700--text {{ `Invoice #${invoice.rid}` }}
            .yz-regular-body-sm.neutral700--text.mt-3 {{ selfPayTotal | displayPrice($currency) }}
      .yz-regular-body-sm.neutral700--text.mt-3 This invoice will be removed from the consolidated e-Invoice list, and a credit note will be created. Click 'Confirm' to proceed.
    yz-dialog-normal-actions
      .d-flex.align-center.justify-end(style="gap: 12px")
        yz-btn(size="lg" text label="Cancel" :disabled="isSubmitting" @click="onCancel")
        yz-btn(size="lg" label="Confirm" :loading="isSubmitting" @click="onConfirm")
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
    invoice: {
      type: Object,
      default: () => ({})
    },
    einvoiceId: {
      type: [Number, String],
      default: null
    },
    transactions: {
      type: Array,
      default: () => ([])
    }
  },
  data: () => ({
    isSubmitting: false
  }),
  computed: {
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    selfPayTotal () {
      return this.transactions.filter(t => t.channel === 'self-pay').reduce((sum, t) => sum + (t.amount || 0), 0)
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    onCancel () {
      this.showDialog = false
    },
    onConfirm () {
      if (!this.einvoiceId) return
      this.isSubmitting = true
      this.$axios.post(`/einvoices/${this.einvoiceId}/invoices/${this.invoice.pid}/remove/`)
        .then(resp => {
          this.showMessage(['success', resp.data?.message || 'Invoice removed successfully'])
          this.$emit('confirm', resp.data)
          this.showDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isSubmitting = false
        })
    }
  }
}
</script>
